import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c30eb6c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0c30eb6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30eb6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c30eb6c')) {
      api.createRecord('0c30eb6c', component.options)
    } else {
      api.reload('0c30eb6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0c30eb6c&scoped=true&", function () {
      api.rerender('0c30eb6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/battleHistory/index.vue"
export default component.exports